export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-ri-at-line', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-ri-arrow-right-double-line', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-ri-mail-add-line', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-ri-chat-new-line',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-ri-chat-new-line',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-ri-heart-line', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-ri-heart-line', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-ri-heart-line', 'text-n-ruby-11'],
  KANBAN_ITEM_ASSIGNMENT: ['i-ri-kanban-view', 'text-n-blue-text'],
  KANBAN_ITEM_UNASSIGNMENT: ['i-ri-kanban-view', 'text-n-blue-text'],
  KANBAN_CHECKLIST_ITEM_ASSIGNMENT: ['i-ri-list-check', 'text-n-blue-text'],
  KANBAN_CHECKLIST_ITEM_UNASSIGNMENT: ['i-ri-list-check', 'text-n-blue-text'],
};
